import { render } from "./PayoutFailPage.vue?vue&type=template&id=2456c698&scoped=true"
import script from "./PayoutFailPage.vue?vue&type=script&lang=js"
export * from "./PayoutFailPage.vue?vue&type=script&lang=js"

import "./PayoutFailPage.vue?vue&type=style&index=0&id=2456c698&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2456c698"]])

export default __exports__